import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx';
import ErrorBoundary from './Components/ErrorBoundary.tsx';
import { installTenantInterceptor } from './utils/tenantApi.ts';

// Install global tenant interceptor for all API calls
installTenantInterceptor();

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
